import _styled from "styled-components";
import React from 'react';
import { getStaticFilesURL } from '@noths/polaris-client-static-files';
import { flag } from "./Flag.styles";
export var Flag = function Flag(_ref) {
  var countryCode = _ref.countryCode,
    countryName = _ref.countryName,
    styles = _ref.styles,
    width = _ref.width;
  var flagURL = getStaticFilesURL('production', "img/flags/".concat(countryCode, ".png"));
  return /*#__PURE__*/React.createElement(_StyledImg, {
    alt: "Country: ".concat(countryName),
    "data-testid": "flag-icon",
    src: flagURL,
    width: width ? "".concat(width, "px") : undefined,
    $_css: [styles, flag]
  });
};
var _StyledImg = /*#__PURE__*/_styled("img").withConfig({
  displayName: "Flag___StyledImg",
  componentId: "sc-cuyyli-0"
})(["", ""], function (p) {
  return p.$_css;
});